import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Business from "./pages/Business";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Popup from "./components/Popup";
import Whatsapp from "./components/Whatsapp";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="business" element={<Business />} />
          <Route path="services" element={<Services />} />
          <Route path="contact" element={<Contact />} />
        </Route>
      </Routes>

      <Popup />
      <Whatsapp />
    </BrowserRouter>
  );
}

export default App;